import script from "./NotFoundView.vue?vue&type=script&lang=ts&setup=true"
export * from "./NotFoundView.vue?vue&type=script&lang=ts&setup=true"

import "./NotFoundView.vue?vue&type=style&index=0&id=4292a50d&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4292a50d"]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog});
